import * as React from "react";
import { Form, Input, Divider } from "antd";
import { AttributeCodebookFormFields } from "../../../common/Constants";
import { IValueListItem } from "../../../model/valuelist/ValueListItem";

const AttributeCodebookForm = ({
  getFieldDecorator,
  translate,
  rowData,
  addNewCodebook
}: {
  getFieldDecorator: any;
  translate: any;
  rowData?: IValueListItem;
  addNewCodebook?: boolean;
}) => {
  return (
    <Form>
      {addNewCodebook && (
        <div>
          <Form.Item
            label={translate("attribute_codebook.label")}
            style={{ backgroundColor: "#f0f0f0", padding: 10, borderRadius: 5 }}
          >
            {getFieldDecorator(AttributeCodebookFormFields.LABEL, {
              initialValue: rowData && rowData.label,
              rules: [
                {
                  required: true,
                  message: translate("attribute_codebook.required_messages", {
                    field: translate("attribute_codebook.label")
                  })
                }
              ]
            })(<Input />)}
          </Form.Item>
          <Divider
            type={"horizontal"}
            style={{ marginTop: 10, marginBottom: 10 }}
          />
          <h4>{translate("attribute_codebook.insert_value")}</h4>
        </div>
      )}
      <Form.Item>
        {getFieldDecorator(AttributeCodebookFormFields.ID, {
          initialValue: rowData && rowData.id
        })(<Input style={{ display: "none" }} />)}
      </Form.Item>
      <Form.Item label={translate("attribute_codebook.code")}>
        {getFieldDecorator(AttributeCodebookFormFields.CODE, {
          initialValue: rowData && rowData.code,
          rules: [
            {
              required: true,
              message: translate("attribute_codebook.required_messages", {
                field: translate("attribute_codebook.code")
              })
            }
          ]
        })(<Input />)}
      </Form.Item>
      <Form.Item label={translate("attribute_codebook.value")}>
        {getFieldDecorator(AttributeCodebookFormFields.VALUE, {
          initialValue: rowData && rowData.value,
          rules: [
            {
              required: true,
              message: translate("attribute_codebook.required_messages", {
                field: translate("attribute_codebook.value")
              })
            }
          ]
        })(<Input />)}
      </Form.Item>
    </Form>
  );
};

export default AttributeCodebookForm;
